import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'projects',
    name: 'Projects',
    description: 'Projects, tasks, time and delivery tracking.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'projects',
    features: [
        { key: 'projects.resource_planning', description: 'Capacity and resource allocation' },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds resource planning',
            features: ['projects.resource_planning'],
            limits: ['user', 'active_user'],
        },
    ],
    limitTypes: ['user', 'active_user'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'tasks',
        'party_master',
    ],
    optionalModules: ['finance', 'hr'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map